import { useEffect } from 'react';
import { debounce } from '@Utils/facade/lodash';
import { LogoMakerState } from './types';

// uses to set multiple fields in the same callback
export const saveStateToStorage = (dataRaw: any, keyStorage: string) => {
  const data = JSON.stringify(dataRaw);
  window.localStorage.setItem(keyStorage, data);
};

// uses debounce to optimization, editor user change events
export const saveStateToStorageWithDebounce = debounce(
  (dataRaw: any, keyStorage: string) => saveStateToStorage(dataRaw, keyStorage),
  1000,
);

/**
 * Save configuration state to local storage
 *
 * @param state LogoMakerState configuration
 * @param keyStorage LogoMakerStorage key
 */
export function useSaveToStorage(state: LogoMakerState, keyStorage: string) {
  useEffect(() => {
    if (state.loaded) {
      saveStateToStorageWithDebounce(state.configuration, keyStorage);
    }
  }, [keyStorage, state]);
}
